import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

export const Faq = () => {
  const { t } = useLang();
  return (
    <section id="faq" className="relative py-28 md:py-36" data-testid="faq-section">
      <div className="mx-auto max-w-7xl px-5 md:px-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <Reveal><Overline>{t.faq.over}</Overline></Reveal>
          <Reveal delay={0.08}><h2 className="mt-6 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white">{t.faq.title}</h2></Reveal>
        </div>
        <Reveal delay={0.12} className="lg:col-span-8">
          <Accordion type="single" collapsible className="border-t border-white/10">
            {t.faq.items.map((it, i) => (
              <AccordionItem key={i} value={`q${i}`} className="border-white/10">
                <AccordionTrigger data-testid={`faq-item-${i}`} className="py-6 text-left font-display text-lg md:text-xl text-white hover:no-underline hover:text-sky-200">
                  <span><span className="font-mono text-xs text-slate-400 mr-4">0{i + 1}</span>{it.q}</span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base text-slate-300 leading-relaxed">{it.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
